<template>
  <withBefore v-if="content.category === 'withBefore'" :content="content"></withBefore>
</template>
<script>
/*
正文组件
*/
import withBefore from "./withBefore.vue";

export default {
  name: "paragraphIndex",
  components: {
    withBefore,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.content_paragraph{
  
}
</style>